<template>
    <v-card class="mr-6">

        <v-card-text class="d-flex align-center justify-center py-1 competence-text">
            <v-img
                :src="element.image.url"
                contain
                :width="element.image.width"
                :height="element.image.height" />
        </v-card-text>

        <v-card-title
            class="pt-0"
            v-html="element.name" />

        <v-card-subtitle
            v-if="element.beginning"
            class="pb-1"
            v-html="'Depuis ' + element.beginning" />

        <v-card-subtitle
            v-if="element.language"
            class="pb-1"
            v-html="element.language" />

        <v-rating
            v-if="element.stars"
            class="px-2 pb-2"
            background-color="grey lighten-2"
            half-icon="mdi-star-half"
            half-increments
            readonly
            length="5"
            size="32"
            :value="element.stars" />
    </v-card>
</template>

<script>
export default {
    name: 'competencesElement',
    props: {
        element: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/variables';

.v-card {
    min-width: 216px !important;

    .competence-text {
        width: 100% !important;
        height: 115px !important;
    }
}
</style>

<style lang="scss">
@import '../../assets/css/variables';
.v-rating .v-icon {
    padding: 4px !important;
    color: $c-red !important;
    caret-color: $c-red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/competences/competencesElement.vue